import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';

const ShopifyApp: React.FC = () => {
  return (
    <Box
      sx={{
        maxWidth: 620,
        mx: 'auto',
        my: 6,
        p: 4,
        borderRadius: '16px',
        backgroundColor: '#f9f9fb',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      }}
    >
      <Typography variant='h5' sx={{ fontWeight: 600, mb: 2 }}>
        Welcome to Beautypass!
      </Typography>
      <Typography variant='body1' sx={{ mb: 3, color: 'text.secondary' }}>
        Thanks for installing the Beautypass app. Please log in to your account to sync your product
        data.
      </Typography>
    </Box>
  );
};

export default ShopifyApp;
